
<div
	class="flow-logs-container flow-add-scrollbar bar-width-6 bar-height-6"
	:background="background"
>
	<!-- eslint-disable-next-line vue/no-mutating-props -->
	<textarea ref="logs-to-format" v-model="content" readonly />
</div>
